import { FC } from 'react';
import { useSnapshot } from 'valtio';
import CollapsiblePanel from '../../elements/CollapsiblePanel/CollapsiblePanel';
import Summary from '../../elements/Summary/Summary';
import { Box } from '@mui/material';
import FiltersHeader from '../../elements/FilterBox/FiltersHeader';
import { splitLongNames } from 'string-utils';
import config from '../config/pipeline-summary-config.json';
import PipelineSummaryFiltersStore from '../store/pipeline-summary-filters-store';
import { toggleFiltersPanel } from '../store/pipeline-summary-store-actions';
import {
  clearFilters,
  clearFilter,
} from '../store/pipeline-summary-filters-store-actions';
import PipelineSummarySidebar from '../components/PipelineSummarySidebar';
import PipelineSummaryStore from '../store/pipeline-summary-store';
import { AppPages } from '../../common/routing/app-navigator';
import { NavLink } from 'react-router-dom';

const PipelineSummarySidebarContainer: FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { total, filtersOpen, loading } = useSnapshot(PipelineSummaryStore);
  const {
    loadingFilters,
    filterBy,
    pipelineSummaryFiltersType,
    pipelineSummaryFiltersTypeSearch,
    numberOfFilters,
    totalFiltered,
    searchValues,
  } = useSnapshot(PipelineSummaryFiltersStore);

  return (
    <CollapsiblePanel
      collapsedSize={config.sidebar.collapsedSize}
      in={filtersOpen}
      togglePanel={toggleFiltersPanel}>
      <PipelineSummarySidebar
        disabled={loading.isPending() || loadingFilters.isPending()}
        filterList={filterBy}
        pipelineFiltersTypeSearch={pipelineSummaryFiltersTypeSearch}
        pipelineFiltersType={pipelineSummaryFiltersType}
        total={total}
        searchValues={searchValues}
        handleFilterClear={clearFilter}>
        <Summary
          linkText='Show Pipeline Issues'
          headerText='Pipeline Summary'
          linkUrl={AppPages.PipelineIssues}
          navComponent={NavLink}
          total={total}
          count={totalFiltered === total ? 0 : totalFiltered}
          onCollapse={toggleFiltersPanel}
        />
        <Box py={1}>
          <FiltersHeader
            numberOfFilters={numberOfFilters}
            filterIssuesBy={filterBy}
            onResetFilters={clearFilters}
            splitFilterTypeName={splitLongNames}
          />
        </Box>
      </PipelineSummarySidebar>
    </CollapsiblePanel>
  );
};

export default PipelineSummarySidebarContainer;
